import { render, staticRenderFns } from "./ItemsGridContainer.vue?vue&type=template&id=24cd0c82&"
import script from "./ItemsGridContainer.vue?vue&type=script&lang=js&"
export * from "./ItemsGridContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports